class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
		this.mobileLinks = el.querySelectorAll('.mobile-top-level-link-clickable');
		this.megaMenuBg = document.querySelector('.site-header__megamenu-bg');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		const body = document.querySelector('body');
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// mobile menu handler 
		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
				});
			});
		}

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());

		// mega menu handler 
		if (this.megaMenuLinks) {
			this.megaMenuLinks.forEach((link) => {

				link.addEventListener('mouseenter', () => {
					// remove active from others
					this.megaMenuLinks.forEach((other) => {
					if (other !== link) {
						other.classList.remove('active');
						other.setAttribute('aria-expanded', false);
					}
					});

					// activate hovered one
					link.classList.add('active');
					link.setAttribute('aria-expanded', true);
					this.megaMenuBg.classList.add('active');
					document.body.classList.add('no-scroll');
				});

				link.addEventListener('click', () => {

					this.megaMenuLinks.forEach((megaMenuLink) => {
						if (megaMenuLink !== link) {
							megaMenuLink.setAttribute('aria-expanded', false);
							megaMenuLink.classList.remove('active');
						}
					})

					if (link.classList.contains('active')) {
						body.classList.remove('no-scroll');
						link.setAttribute('aria-expanded', false);
						link.classList.remove('active');
						this.megaMenuBg.classList.remove('active');
					} else {
						body.classList.add('no-scroll');
						link.setAttribute('aria-expanded', true);
						link.classList.add('active');
						this.megaMenuBg.classList.add('active');
					}

				});
			});
		}

		if (this.megaMenuBg) {
			this.megaMenuBg.addEventListener('click', () => {
				this.megaMenuBg.classList.remove('active');
				body.classList.remove('no-scroll');

				this.megaMenuLinks.forEach((megaMenuLink) => {
					megaMenuLink.setAttribute('aria-expanded', false);
					megaMenuLink.classList.remove('active');
				})
			})
		}

		document.addEventListener('keydown', evt => {
			if (evt.key === 'Escape') {
				this.megaMenuLinks.forEach((menu) => {
					menu.classList.remove('active');
				});

				body.classList.remove('no-scroll');
				this.megaMenuBg.classList.remove('active');
			}
		});

	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	removeSearchValue() {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
